var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 3.9585C8.50358 3.9585 7.29102 5.17106 7.29102 6.66683C7.29102 8.1626 8.50358 9.37516 9.99935 9.37516C11.4951 9.37516 12.7077 8.1626 12.7077 6.66683C12.7077 5.17106 11.4951 3.9585 9.99935 3.9585ZM12.3812 9.82859C13.3388 9.10612 13.9577 7.95875 13.9577 6.66683C13.9577 4.4807 12.1855 2.7085 9.99935 2.7085C7.81322 2.7085 6.04102 4.4807 6.04102 6.66683C6.04102 7.95875 6.65994 9.10612 7.61745 9.82859C5.22945 10.7766 3.54102 13.1079 3.54102 15.8335V16.6668C3.54102 17.012 3.82084 17.2918 4.16602 17.2918C4.51119 17.2918 4.79102 17.012 4.79102 16.6668V15.8335C4.79102 12.957 7.12287 10.6252 9.99935 10.6252C12.8758 10.6252 15.2077 12.957 15.2077 15.8335V16.6668C15.2077 17.012 15.4875 17.2918 15.8327 17.2918C16.1779 17.2918 16.4577 17.012 16.4577 16.6668V15.8335C16.4577 13.1079 14.7692 10.7766 12.3812 9.82859Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3cce2c64cc426ebe1d477c88dd9a2fb4.svg";
export { ForwardRef as ReactComponent };